export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9061.44f0480f.jpg";